import { Loading } from '@hogwarts/ui-components-core';
import qs from 'qs';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import getEnvironment from '../../services/getEnvironment';
import authenticationService from '../../services/authentication';

const EmailChange = () => {
  const history = useHistory();
  const location = useLocation();
  const [status, setStatus] = useState<
    'LOADING' | 'OK' | 'ERROR'
  >('LOADING');
  const [message, setMessage] = useState<string>('');
  const isLoggedIn = (() => {
    try {
      return authenticationService.isAuthenticated();
    } catch (e) {
      return false;
    }
  })();

  useEffect(() => {
    const run = async () => {
      const query = location.search
        ? qs.parse(location.search.substring(1))
        : {};
      const token =
        (typeof (query as any).tempEmailToken === 'string'
          ? (query as any).tempEmailToken
          : '') ||
        (typeof (query as any).id === 'string' ? (query as any).id : '');
      const id = typeof token === 'string' ? token.trim() : '';
      if (!id) {
        setStatus('ERROR');
        setMessage('Invalid verification link.');
        return;
      }

      try {
        const uri = getEnvironment().serverUri;
        // Redirect to server endpoint which renders an auto-submitting POST form.
        window.location.href = `${uri}/api/v1/users/confirmemailchange?tempEmailToken=${encodeURIComponent(
          id
        )}`;
      } catch (e) {
        setStatus('ERROR');
        setMessage('Unable to verify email change.');
      }
    };
    run();
  }, [location.search]);

  if (status === 'LOADING') return <Loading showLogo />;

  const title =
    status === 'OK'
      ? 'Email updated'
      : 'Email update failed';
  const intentClass =
    status === 'OK'
      ? 'bp5-intent-success'
      : 'bp5-intent-danger';
  const primaryAction = () => {
    if (isLoggedIn) {
      history.push('/settings?setting=preferences');
    } else {
      history.push('/');
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
      }}
    >
      <div className="bp5-card bp5-elevation-2" style={{ maxWidth: 560, width: '100%' }}>
        <h2 style={{ marginTop: 0 }}>{title}</h2>
        <div className={`bp5-callout ${intentClass}`} style={{ marginBottom: 16 }}>
          {message}
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button className="bp5-button" onClick={() => history.push('/')}>
            Home
          </button>
          <button
            className="bp5-button bp5-intent-primary"
            onClick={primaryAction}
          >
            {isLoggedIn ? 'Back to Settings' : 'Continue'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailChange;

